export const EXISTING_INDUSTRY_URL = 'https://docs.google.com/spreadsheets/d/1XZYEMzVfuXX94G3Vy3tCOrNgTC-dNqPugo-C48jzsps/edit?usp=sharing';

export const NEW_INDUSTRY_DOCS = [
  {
    label: '分析設定',
    url: 'https://docs.google.com/spreadsheets/d/1yrcKOetyBBJ3BFXzk8BTRnqmnFHQZAvR81RoyYvZnSM/edit?usp=sharing'
  },
  {
    label: '產品/品牌比對清單',
    url: 'https://docs.google.com/spreadsheets/d/10PzEDIV3L3sjagTD1z57LAHEvb4wlL3jOrHfgEbjT_I/edit?usp=sharing'
  },
  {
    label: '標籤類別及定義',
    url: 'https://docs.google.com/spreadsheets/d/1ut8RPp9Y7tU0mmpPhOyuRxg4NWVOCG0_rEKZN61cTfc/edit?usp=sharing'
  }
];
